import React from "react";
import SponsorCodeContext from "./SponsorCodeContext.js";

export default function useSponsorCode() {
  return React.useContext(SponsorCodeContext);
}
